import { custom } from './custom';
import { customMetadata } from './customMetadata';
import { reports } from './reports';
import { savedReports } from './savedReports';

import { combineReducers } from '@reduxjs/toolkit';

export default combineReducers({ reports, savedReports, custom, customMetadata });
